const SceneKeys = {
  BattlePreloader: 'battle-preloader',
  Battle: 'battle',
};

export default SceneKeys;
